import ky from "ky";
import { useState } from "react";

const useFileDownload = () => {
  const [downloading, setDownloading] = useState(false);

  // eslint-disable-next-line unicorn/consistent-function-scoping
  const getFileNameFromUrl = (url: string) => {
    const urlObject = new URL(url);
    const pathName = urlObject.pathname;
    return pathName.split("/").pop(); // 获取最后一部分，即文件名
  };

  const download = async (url: string) => {
    const fileName = getFileNameFromUrl(url);

    if (!fileName) {
      // eslint-disable-next-line lingui/no-unlocalized-strings
      console.log("no fileName");
      return;
    }

    setDownloading(true);

    try {
      const response = await ky.get(url);
      const blob = await response.blob();
      const link = document.createElement("a");
      link.href = URL.createObjectURL(blob);
      link.download = fileName;
      document.body.append(link);
      link.click();
      link.remove();
    } catch (error) {
      console.log(error);
    } finally {
      setDownloading(false);
    }
  };
  return {
    downloading,
    download,
  };
};
export default useFileDownload;
